import moment from 'moment';
import { getEstimateStatuses } from '../../HttpRequests/estimateStatuses';
import { loadEstimateStatuses } from '../State/estimateStatuses';

let lastGetTimestamp = null;

const cacheTTL = 60000;

export default ({ force } = {}) => async (dispatch) => {

  try {

    if (!force && lastGetTimestamp) {

      const now = Number(moment().format('x'));

      if (now < (lastGetTimestamp + cacheTTL)) return;
    }
      
    lastGetTimestamp = Number(moment().format('x'));

    const response = await getEstimateStatuses();

    dispatch(loadEstimateStatuses(response.data.data));

  } catch (error) {
    
    throw error;

  }
}